<template>
  <button
    class="w-full md:py-3 flex justify-center items-center md:gap-3 gap-1 text-white focus:outline-none"
  >
    <slot />
  </button>
</template>
